"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM, animations, imageTypes } from from '../../../../utils/styles/index';
// import { url } from from '../../../../utils/index';

/* ++++++++++ --------------- EXPORT : TAB CONTENT : STYLES--------------- ++++++++++ */

var _default = {
  tabcontent: {}
};
exports.default = _default;